module.exports = __webpack_public_path__ + "static/media/m_lipshape_largefull.532cf291.png";